"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { LitElement, html, nothing } from "lit";
import { state } from "lit/decorators.js";
import { STCComponentMixin } from "../../../common/mixins/stc_component_mixin";
class ApplicationsListTemplate {
  render({ type }) {
    return (application) => {
      return html`
        <li kind="no-dot" class="applicationTileContainer reset">
          ${application.is_expired ? nothing : html`<hi-tile class="applicationTileInformation">
                <div class="width-100">
                  <hi-link
                    href="${application.href}"
                    class="text-sz-l pbsx applicationTileInformation-heading"
                  >
                    ${application.application_name}
                  </hi-link>

                  <section class="applicationTileText">
                    <ul class="mbs mts">
                      ${application.updated_at ? html`<li kind="no-dot">
                            <hi-text class="text-sz-m"
                              >Updated ${application.updated_at}</hi-text
                            >
                          </li>` : nothing}
                      ${application.submitted_at ? html`<li kind="no-dot">
                            <hi-text class="text-sz-m"
                              >Submitted ${application.submitted_at}</hi-text
                            >
                          </li>` : nothing}
                      ${application.due_date ? html`<li kind="no-dot">
                            <hi-text class="text-sz-m"
                              >Due ${application.due_date}</hi-text
                            >
                          </li>` : nothing}
                    </ul>
                    <hi-text
                      theme="${application.status_theme}"
                      class="text-right mbs applicationFormTileText"
                      >${application.status}
                    </hi-text>
                  </section>
                </div>
              </hi-tile>`}
        </li>
      `;
    };
  }
}
const template = new ApplicationsListTemplate();
export class ApplicationsList extends STCComponentMixin(LitElement) {
  constructor() {
    super(...arguments);
    this.applications = [];
    this.type = {
      fields: {
        application_name: {
          name: "application_name",
          title: "",
          render_type: "text"
        }
      },
      mutations: {
        page_size: 10,
        total_size: this.applications.length
      }
    };
    this.settings = {
      hidden: {
        footer: true,
        add_row: true,
        global_search: true,
        clear_all_limits: true
      },
      messages: {
        state_empty: {
          title: "",
          description: "You have no active applications at this time"
        }
      }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.fetchApplications();
  }
  fetchApplications() {
    const data = this.getAttribute("data-applications");
    if (data) {
      this.applications = JSON.parse(data);
      this.settings.hidden.footer = this.applications.length <= 10;
    }
  }
  render() {
    return html`
      <vi-list
        class="applicationList"
        mode="item"
        .type=${this.type}
        .settings=${this.settings}
        .input=${this.applications}
        .template=${template}
        fit-height
        disallow-header
        aesthetic="invisible"
      >
      </vi-list>
    `;
  }
}
__decorateClass([
  state()
], ApplicationsList.prototype, "applications", 2);
customElements.define("applications-list", ApplicationsList);
